<template>
  <div>
    <!-- Navigation -->
    <navigation
      @prev="$emit('prev')"
      @next="$emit('next')"
      :activeStepIndex="activeStepIndex"
      :$v="$v"
      :processing-api="processingApi"
    />

    <!-- Form -->
    <div class="form-group">
      <label :class="survey.id == 552 ? 'color-avai' : 'black'" class="title-bold" for="nome">{{ $t('whats_first_name') }}</label>
      <div class="error mt-n2" v-if="$v.profile.Name1.$error">
        <span class="error " v-if="!$v.profile.Name1.required">{{ $t('name') + $t('is_required') }}</span>
        <span class="error mt-n2" v-else-if="!$v.profile.Name1.minLength">{{$t('name')}} {{$t('min_length')}} {{$v.profile.Name1.$params.minLength.min}} {{$t('letters')}}</span>
      </div>
      <input
        type="text"
        class="form-control"
        id="name1"
        :placeholder= "$t('type_here')"
        v-model="profile.Name1"
        @input="sanitizeName1"
        @keydown.enter="focusOn('name2')"
        @blur="$v.profile.Name1.$touch()"
      />

      <label :class="survey.id == 552 ? 'color-avai' : 'black'" class="title-bold" for="nome">{{$t('whats_last_name')}}</label>
      <div class="error mt-n2" v-if="$v.profile.Name2.$error">
        <span class="error " v-if="!$v.profile.Name2.required">{{$t('last_name') + $t('is_required')}}</span>
        <span class="error mt-n2" v-if="!$v.profile.Name2.minLength">{{$t('last_name')}} {{$t('min_length')}} {{$v.profile.Name2.$params.minLength.min}} {{$t('letters')}}</span>
      </div>
      <input
        type="text"
        class="form-control"
        @input="sanitizeName2"
        id="name2"
        :placeholder= "$t('type_here')"
        v-model="profile.Name2"
        @keyup.enter="goToNextStep"
        @blur="$v.profile.Name2.$touch()"
      />
    </div>

    <!-- Button -->
    <section class="row">
      <div class="col-12 mt-5 mx-auto col-md-6">
        <button
          :style="
            style.surveyBtnColor
              ? { backgroundColor: style.surveyBtnColor }
              : { backgroundColor: style.homeBtnColor }
          "
          type="submit"
          class="w-100 btn btn-primary btn-block my-3"
          @click="goToNextStep"
          :disabled="$v.$invalid"
        >
          {{ $t('advance') }}
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
            v-if="processingApi"
          ></span>
        </button>
      </div>
    </section>
  </div>
</template>

<script>
import {minLength, required} from 'vuelidate/lib/validators'
import Navigation from "@/components/registration/components/Navigation";

export default {
  name: "Name",
  components: {Navigation},
  props: {
    profile: {
      type: Object,
      required: true
    },
    processingApi: {
      type: Boolean,
      required: true
    },
    activeStepIndex: {
      type: Number,
      required: true
    }
  },
  validations: {
    profile: {
      Name1: {
        required,
        minLength: minLength(2)
      },
      Name2: {
        required,
        minLength: minLength(2)
      }
    }
  },
  computed: {
    style() {
      return this.$store.state.template.style;
    },
    survey() {
      return this.$store.state.template.survey;
    },
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    }
  },
  mounted() {
    if (!this.isMobile || (this.isMobile && this.activeStepIndex !== 0)) this.focusOn('name1')
  },
  methods: {
    focusOn(el) {
      document.getElementById(el).focus();
    },
    goToNextStep() {
      this.$store.commit("SET_Name", this.profile.Name1);
      if (!this.$v.$invalid) this.$emit('next')
    },
    sanitizeName1(event) {
      const inputValue = event.target.value;
      this.profile.Name1 = inputValue.replace(/[0-9]/g, '');
    },
    sanitizeName2(event) {
      const inputValue = event.target.value;
      this.profile.Name2 = inputValue.replace(/[0-9]/g, '');
    }
  },
};
</script>
<style>
.color-avai{
  color: #123654 !important;
}
</style>
